import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Overlay, ScrollArea } from '@mantine/core';

import { useAddBotAllowedUser } from '../../api/addAllowedUser';
import { botTypes } from '../../types';

import { AllowedUserForm } from './AllowedUserForm';

export const AddModal = NiceModal.create(({ user }: { user?: botTypes.AllowedUser }) => {
  const modal = useModal();

  const addAllowedUser = useAddBotAllowedUser({ config: { onSuccess: modal.hide } });

  return (
    <Modal
      title="Новый разрешенный пользователь"
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={modal.remove}
      closeOnEscape={!addAllowedUser.isLoading}
      closeOnClickOutside={!addAllowedUser.isLoading}
      withCloseButton={!addAllowedUser.isLoading}
      scrollAreaComponent={ScrollArea.Autosize}
    >
      {addAllowedUser.isLoading && <Overlay opacity={0} />}
      <AllowedUserForm
        onSubmit={(data) => addAllowedUser.mutate({ ...data })}
        isLoading={addAllowedUser.isLoading}
        initialValues={
          user && {
            name: user.name,
          }
        }
      />
    </Modal>
  );
});
